import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0000',
    ecrans: ['00-2',
             '01-2']
});
